module.exports = __webpack_public_path__ + "static/media/datasheet_team_row2_image.fae85f07.png";